import { gql } from '@apollo/client';

export const BondBankingLogin = gql`
  mutation BondBankingLogin($password: String!, $email: String) {
    bondBankingLogin(password: $password, email: $email) {
      customer {
        id
      }
      loginResponse {
        standardToken {
          accessToken
        }
      }
    }
  }
`;

export const EnterpriseLogin = gql`
  mutation EnterpriseLogin($password: String!, $email: String!) {
    enterpriseLogin(password: $password, email: $email) {
      loginResponse {
        standardToken {
          accessToken
        }
      }
    }
  }
`;

export const InviteEnterpriseClientV2 = gql`
  mutation InviteEnterpriseUser($input: EnterpriseUserInviteInput!) {
    inviteEnterpriseUser(input: $input)
    # {
    #   email
    #   firstName
    #   id
    #   lastName
    #   phoneNumber
    #   role
    #   enterprise {
    #     id
    #     logoId
    #     name
    #     status
    #     address1
    #     address2
    #   }
    # }
  }
`;

export const RegisterEnterpriseClient = gql`
  mutation CreateEnterpriseUserAccount($input: EnterpriseUserAccountInput!) {
    createEnterpriseUserAccount(input: $input) {
      tokenResponse {
        accessToken
        expiresIn
      }
      user {
        id
        clientId
        firstName
        lastName
        role
        type
        taxId
        status
        inviteStatus
        email
        phones {
          phoneType
          phoneNumber
          phoneExt
          isPrimary
        }
        lastSeen
        emailNotification
        textNotification
        modifiedBy
        modifiedOn
        createdBy
        createdOn
      }
      # employeeProfile {
      #   id
      #   email
      #   firstName
      #   lastName
      #   middleName
      #   clientId
      #   status
      # }
    }
  }
`;

export const CreateEnterpriseClient = gql`
  mutation CreateEnterpriseClient($input: ClientEnterpriseInput!) {
    createEnterpriseClient(input: $input)
  }
`;

export const CreateClientAddress = gql`
  mutation CreateClientAddress($input: BasicAddressInput!) {
    createClientAddress(input: $input)
  }
`;

export const UpsertClientLogoImage = gql`
  mutation UpsertClientLogoImage($clientId: ID) {
  upsertClientLogoImage(clientId: $clientId) {
    id
    fileName
    bucket
    presignedURL
    publicURL
  }
}
`;

export const UpdateClient = gql`
  mutation UpdateClient($input: ClientUpdateInput!, $updateClientId: ID!) {
    updateClient(input: $input, id: $updateClientId)
  }
`;

export const CreateEnterpriseEmployeeFile = gql`
  mutation CreateEmployeeCSV {
    createEmployeeCSV {
      bucket
      fileName
      id
      presignedURL
    }
  }
`;

export const UpdateEnterpriseUser = gql`
    mutation UpdateEnterpriseUser($input: ClientUserUpdateInput!) {
    updateEnterpriseUser(input: $input)
  }
`;

export const UpdateClientUser = gql`
   mutation UpdateClientUser($input: ClientUserUpdateInput!, $updateClientUserId: ID!) {
    updateClientUser(input: $input, id: $updateClientUserId)
  }
`;

export const UpdateEmployee = gql`
  mutation UpdateEmployee($input: EmployeeUpdateInput!, $updateEmployeeId: ID!) {
    updateEmployee(input: $input, id: $updateEmployeeId) {
      id
    }
  }
`;

export const CreateEnterpriseEmployees = gql`
  mutation CreateEnterpriseEmployees(
    $fileMetadataId: ID!
    $mapping: EmployeeMappingInput!
  ) {
    triggerCreateEmployees(mapping: $mapping, fileMetadataId: $fileMetadataId)
    # createEnterpriseEmployees(fileId: $fileId, mappings: $mappings) {
    #   errorRecords {
    #     message
    #     row
    #   }
    #   file {
    #     id
    #     presignedURL
    #     fileName
    #   }
    #   id
    #   status
    #   uploadedEmployeeStat {
    #     duplicate
    #     error
    #     modified
    #     new
    #     total
    #   }
    # }
  }
`;

export const UpdateEnterpriseClient = gql`
  mutation UpdateClientUser($input: ClientUserUpdateInput!, $updateClientUserId: ID!) {
    updateClientUser(input: $input, id: $updateClientUserId)
  }
`;